import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { FilterEnum } from 'src/app/core/api/models/filter-enum';
import { ConsoleService } from 'src/app/core/services/console.service';

@Component({
    selector: 'dynamic-grid',
    templateUrl: './dynamic-grid.html',
    styleUrls: ['./dynamic-grid.scss'],
    standalone: false
})
export class DynamicGridComponent implements OnInit, OnDestroy {
  componentVocab = 'components.dynamicGrid.props.';

  public columns: string[] = [];
  public columnMap: Array<FilterEnum> = [];
  public extendingMap: Array<ExtendProperty> = [];
  public data: any[];

  @Output()
  OnPropertyChange: EventEmitter<ExtendPropertyChangeEvent> =
    new EventEmitter<ExtendPropertyChangeEvent>();

  constructor(public CD: ChangeDetectorRef) {}

  get ExtendPropertyType() {
    return ExtendPropertyType;
  }

  /**
   * this method used to assing the map of grid
   */
  public SetColumns(columns: Array<FilterEnum>) {
    this.columnMap = columns;
    this.prepareTheColumns();
  }
  /**
   * this method create list of column's for rendering grid
   */
  private prepareTheColumns() {
    this.columns = [];
    this.columnMap.forEach((item) => {
      this.columns.push(item.enumName);
    });
  }
  /**
   * this method load the data into the grid
   * @param input the input data as array
   */
  public setData(input: any[], extendedProps: Array<ExtendProperty>) {
    this.data = input;
    this.extendingMap = [];
    if (this.data.length > 0) {
      let keys = Object.keys(this.data[0]);
      keys.forEach((item) => {
        if (this.columns.indexOf(item) < 0) {
          this.extendingMap.push({
            Name: item,
            DefaultValue: 0,
            IsRequired: true,
            MostGreaterThan: '',
            Type: ExtendPropertyType.Label,
            MaxValue: '',
            MinValue: '',
            OnGenerationFieldName: '',
            DefaultValuePropName: '',
            MostLowerThan: '',
          });
        }
      });
    }
    extendedProps.forEach((item) => {
      this.extendingMap.push(item);
    });
    this.setDefaultExtendedValues(extendedProps);
    this.CD.detectChanges();
  }
  /**
   *
   * @param prop this method return the value of each extended property
   * @param item
   * @returns
   */
  private getExtendPropertyValue(prop: ExtendProperty, item: any) {
    type itemKey = keyof typeof item;
    const itemField = prop.Name as itemKey;
    let value = item[itemField];
    if (value != null || value != undefined) {
      if (prop.Type == ExtendPropertyType.Str) return value.toString();
      if (prop.Type == ExtendPropertyType.Num) return value as Number;
      if (prop.Type == ExtendPropertyType.Bool) return value as boolean;
    }
    return prop.DefaultValue;
  }
  /**
   * this method called with the extended properties type's to set the value ot data
   * @param prop prop map
   * @param item object to set data
   * @param value the value most be set to the object
   */
  public setExtendedPropertyValue(
    prop: ExtendProperty,
    item: any,
    value: any,
    isBulk: boolean = false
  ) {
    if (value == null || value == undefined || value == 0) value = 0;
    else if (value.target) value = value.target.value;
    type itemKey = keyof typeof item;
    const itemField = prop.Name as itemKey;
    item[itemField] = value;
    if (!isBulk) {
      //here we most check other prop's with script's on them
      for (let index = 0; index < this.extendingMap.length; index++) {
        let prop = this.extendingMap[index];
        if (prop.MostGreaterThan != '') {
          let col = prop.Name as itemKey;
          let tmpval = item[col];
          let tmpnumber = this.runSimpleNumberScript(
            prop.MostGreaterThan,
            item
          );
          if (tmpval < tmpnumber) item[col] = tmpnumber;
        }
        if (prop.MostLowerThan != '') {
          let col = prop.Name as itemKey;
          let tmpval = item[col];
          let tmpnumber = this.runSimpleNumberScript(prop.MostLowerThan, item);
          if (tmpval > tmpnumber) item[col] = tmpnumber;
        }
      }
      this.OnPropertyChange.emit({
        Item: item,
        PropertyName: prop.Name,
        Value: value,
      });
    }
    ConsoleService.info('data is : ', this.data);
  }

  /**
   * this method load all row's default extended values
   * @param extendedProps the extending map
   */
  private setDefaultExtendedValues(extendedProps: Array<ExtendProperty>) {
    let tmpdata: any[] = [];
    this.data.forEach((data) => {
      extendedProps.forEach((prop) => {
        if (prop.Type != ExtendPropertyType.Label) {
          if (prop.DefaultValuePropName == '')
            this.setExtendedPropertyValue(prop, data, prop.DefaultValue, true);
          else {
            type sourceKey = keyof typeof data;
            let col = prop.DefaultValuePropName as sourceKey;
            let value = data[col];
            if (value == null) value = prop.DefaultValue;
            this.setExtendedPropertyValue(prop, data, value, true);
          }
        }
      });
      tmpdata.push(data);
    });
    //now most set data
    this.data = tmpdata;
  }

  public td_GetValue(item: any, column: string): any {
    type itemKey = keyof typeof item;
    let prop = column as itemKey;
    let value = item[prop];
    if (value == null || value == undefined) return '';
    for (let index = 0; index < this.columnMap.length; index++) {
      let col = this.columnMap[index];
      if (col.enumName == column)
        for (let sindex = 0; sindex < col.enumValues.length; sindex++) {
          if (col.enumValues[sindex].key == value)
            return col.enumValues[sindex].value;
        }
    }
    return value;
  }

  public getData(): any[] {
    let result: any[] = [];
    for (let dataIndex = 0; dataIndex < this.data.length; dataIndex++) {
      let itemData = this.data[dataIndex];
      let newItem: Object = {};
      type sourceKey = keyof typeof itemData;
      type destinationKey = keyof typeof newItem;
      //first loop use the column's
      for (let colIndex = 0; colIndex < this.columns.length; colIndex++) {
        let col = this.columns[colIndex] as sourceKey;
        let dcol = this.lowercaseFirstLetter(
          this.columns[colIndex]
        ) as destinationKey;
        let value = itemData[col];
        newItem[dcol] = value;
      }
      //now most extend the new item with extra map of readonly prop's
      for (let eIndex = 0; eIndex < this.extendingMap.length; eIndex++) {
        let eprop = this.extendingMap[eIndex];
        if (eprop.Type == ExtendPropertyType.Label) {
          let col = eprop.Name as sourceKey;
          let dcol = this.lowercaseFirstLetter(eprop.Name) as destinationKey;
          let value = itemData[col];
          newItem[dcol] = value;
        }
      }
      //now most extend the new item with extra map of editable prop's
      for (let eIndex = 0; eIndex < this.extendingMap.length; eIndex++) {
        let eprop = this.extendingMap[eIndex];
        if (eprop.Type != ExtendPropertyType.Label) {
          let col = eprop.Name as sourceKey;
          let dcol = this.lowercaseFirstLetter(eprop.Name) as destinationKey;
          if (eprop.OnGenerationFieldName != '')
            dcol = eprop.OnGenerationFieldName as destinationKey;
          let value = itemData[col];
          newItem[dcol] = value;
        }
      }
      //now most push the item to the result
      result.push(newItem);
    }
    return result;
  }

  private lowercaseFirstLetter(input: string): string {
    if (input.length > 0) {
      let c = input.toLowerCase();
      return c[0] + input.substring(1);
    }
    return input;
  }

  private isNumber(a: any): boolean {
    return typeof a === 'number';
  }

  private isString(a: any): boolean {
    return typeof a === 'string';
  }

  public getItemPropMinValue(prop: ExtendProperty, item: object) {
    if (prop.MostGreaterThan != '') {
      //min val most fetch from item
      let value = this.runSimpleNumberScript(prop.MostGreaterThan, item);
      if (value) return value;
    }
    if (this.isNumber(prop.MinValue)) {
      return prop.MinValue;
    }
    if (this.isString(prop.MinValue)) {
      type sourceKey = keyof typeof item;
      let col = prop.MinValue as sourceKey;
      let value = item[col];
      return value;
    }
  }

  public getItemProMaxValue(prop: ExtendProperty, item: object) {
    if (prop.MostLowerThan != '') {
      //min val most fetch from item
      let value = this.runSimpleNumberScript(prop.MostLowerThan, item);
      if (value) return value;
    }
    if (this.isNumber(prop.MaxValue)) {
      return prop.MaxValue;
    }
    if (this.isString(prop.MaxValue)) {
      type sourceKey = keyof typeof item;
      let col = prop.MaxValue as sourceKey;
      let value = item[col];
      return value;
    }
  }

  public runSimpleNumberScript(script: string, model: object) {
    type itemType = keyof typeof model;
    //first most parse string to simple tree
    let tree: string[] = [];
    let operators = ['+', '-', '*', '/'];
    //first read string
    let tmpstr = '';
    for (let charCounter = 0; charCounter < script.length; charCounter++) {
      let curChars = script[charCounter];
      if (operators.indexOf(curChars) >= 0) {
        tree.push(tmpstr.trim());
        tmpstr = '';
        tree.push(curChars);
      } else {
        tmpstr = tmpstr + curChars;
      }
      if (tmpstr.length > 0 && charCounter == script.length - 1) {
        tree.push(tmpstr.trim());
      }
    }
    //now most calculate the tree
    let lastOp = '=';
    let retVal = 0;
    for (let index = 0; index < tree.length; index++) {
      let curitem = tree[index];
      if (operators.indexOf(curitem) >= 0) {
        //is operator
        lastOp = curitem;
      } else {
        let tmpval = 0;
        if (!isNaN(Number.parseInt(curitem))) tmpval = Number.parseInt(curitem);
        else {
          let col = curitem as itemType;
          tmpval = model[col] as number;
        }
        if (tmpval == null || tmpval == undefined) tmpval = 0;
        if (lastOp == '=') retVal = tmpval;
        if (lastOp == '+') retVal += tmpval;
        if (lastOp == '-') retVal -= tmpval;
        if (lastOp == '*') retVal *= tmpval;
        if (lastOp == '/') retVal /= tmpval;
      }
    }
    return retVal;
  }

  ngOnDestroy(): void {}
  ngOnInit(): void {}
}

export class ExtendPropertyChangeEvent {
  public PropertyName: string;
  public Item: any;
  public Value: any;
}

export enum ExtendPropertyType {
  Str = 0,
  Num = 1,
  Bool = 2,
  Label = 3,
}

export class ExtendProperty {
  /**
   * name of property
   */
  public Name: string;
  /**
   * type of property
   */
  public Type: ExtendPropertyType;
  /**
   * the default value of property
   */
  public DefaultValue: any;
  /**
   * the default value most copy from property
   */
  public DefaultValuePropName: string;
  /**
   * should property most set by the user
   */
  public IsRequired: boolean;
  /**
   * simple number script the value most grater than that
   */
  public MostGreaterThan: string;
  /** simple number script the value most lower than that */
  public MostLowerThan: string;
  /** this is the min value requierd for number input if is number the min value else is string is field name*/
  public MinValue: Number | string;
  /** this is the max value if is number the max value set to it else it's field name of max value */
  public MaxValue: Number | string;
  /** on generate respone if this field is setted then the generated data fieldName is here */
  public OnGenerationFieldName: string;
}
